export default __webpack_public_path__ + "static/media/Marvin-pc.1f018c08.png";